import { Component, Input } from '@angular/core'
import { WebsitePreviewItemContext } from './ibranson-preview.iface'

@Component({
  selector: 'app-ib-info',
  templateUrl: './ib-info.component.html',
  standalone: false,
})
export class IbInfoComponent {
  @Input() item: WebsitePreviewItemContext = {}
}
